import {
  GET_SEARCHBAR_DATA_FAIL,
  GET_SEARCHBAR_DATA_REQUEST,
  GET_SEARCHBAR_DATA_SUCCESS,
} from "../../types/admin/searchbarTypes";

export const searchbarDataReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SEARCHBAR_DATA_REQUEST:
      return {
        ...state,
        searchbarLoading: true,
      };
    case GET_SEARCHBAR_DATA_SUCCESS:
      return {
        ...state,
        searchbarLoading: false,
        searchbarList: payload,
        searchbarError: "",
      };
    case GET_SEARCHBAR_DATA_FAIL:
      return {
        ...state,
        searchbarLoading: false,
        searchbarError: payload,
        searchbarList: [],
      };
    default:
      return state;
  }
};
